import { render, staticRenderFns } from "./WorkWarningDialog.vue?vue&type=template&id=7260d627"
import script from "./WorkWarningDialog.vue?vue&type=script&lang=js"
export * from "./WorkWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports